import React from 'react'

const Home = () => {
    return (
        <div className="content">
            <img className="imageStyle" src="/images/logo.svg" alt="HawkGen" />

        </div>
    )
}

export default Home
